import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ParsedNumber, format, parseNumber } from 'libphonenumber-js';

@Component({
  template: `
    @if (phoneLink) {
      <div class="value">
        <a [href]="phoneLink">
          {{ readonlyPhone }}
        </a>
      </div>
    } @else {
      @if (value) {
        <div class="value">{{ value }}</div>
      }
      @if (!value) {
        <glxy-blank-value />
      }
    }
  `,
  styleUrls: ['./phone.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PhoneRendererComponent {
  private _value = '';
  readonlyPhone = '';
  phoneLink = '';

  private setupPhoneValues(): void {
    const parsedNumber = parseNumber(this._value, {
      defaultCountry: 'US',
    });
    if (Object.keys(parsedNumber).length === 0) {
      this.readonlyPhone = '';
      this.phoneLink = '';
      return;
    }

    this.readonlyPhone = format(parsedNumber as ParsedNumber, 'INTERNATIONAL');
    this.phoneLink = format(parsedNumber as ParsedNumber, 'RFC3966');
  }

  get value(): string {
    return this._value;
  }
  set value(v: string) {
    this._value = v;
    this.setupPhoneValues();
  }
}
